// extracted by css-extract-rspack-plugin
export default {"menuPaper":"ContextMenu_menuPaper__PRpzz"};